import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { firebaseConfig } from '~/config/const';

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export const urlNewsletterSubscription = 'https://b952e082.sibforms.com/serve/MUIEAAg-Tqyodqdtt4icyucfOpEoOnjvvq2Z2CejMSRQiZRKw7SzqoUbpCPswb82tEFcEQLZQPG8DdC-guVsSOLiF38TZwC6p8v_tImxap9RI9KzhO9mQt6L5Zzhp5K3Mm36052TEhMLx2_d_288QCVBTAq2V380pCaY5vORSSlqh4BLqLOSXEYZ8AJkSIDJZ026_a5ePQEqtPAo'